import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import dayjs from "dayjs"
import withRouter from "components/Common/withRouter"
import { insertStatusReport, updateStatusReport } from "helpers/database_helper"
import sanitizeHtml from "sanitize-html"
import {
  Card,
  Row,
  Col,
  Form,
  Alert,
  Label,
  FormGroup,
  ButtonGroup,
  Button,
  Modal,
  ModalBody,
} from "reactstrap"
import { DatePicker, Switch, Steps, Select, Input as AntdInput } from "antd"
import { useFormik } from "formik"
import * as Yup from "yup"
import { bulletinSanitizeSettings, showToast } from "utils/general"
import DisturbanceListItem from "pages/LandingPage/DisturbanceListItem"
import { handleExample } from "./handleExample"
import ReactQuill from "react-quill"
const { Option } = Select
const { TextArea } = AntdInput;

// Quill toolbar & formats
const quillModules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
}
const quillFormats = [
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "link",
]

const ErrorBulletinsModal = props => {
  const [selection, setSelection] = useState(null)
  const [selectedLang, setSelectedLang] = useState(1)
  const [ongoingInsert, setOngoingInsert] = useState(false)
  const [example, setExample] = useState(null)
  const [error, setError] = useState(null)
  const [currentStep, setCurrentStep] = useState(0)
  const [initialValues, setInitialValues] = useState({
    id: 0,
    current_status: 1,
    target_groups: [],
    published: false,
    start_time: dayjs(),
    end_time: dayjs(0),
    header_fi: "",
    header_en: "",
    header_sv: "",
    description_fi: "",
    description_en: "",
    description_sv: "",
  })

  // Steps for publication
  const modalSteps = [
    {
      title: props.t("General"),
    },
    {
      title: props.t("Description"),
    },
  ]

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  useEffect(() => {
    if (props.modal) createBulletin()
  }, [props.modal])

  useEffect(() => {
    setSelection(props.selection)
  }, [props.selection])

  useEffect(() => {
    if (selection !== null) {
      setInitialValues(selection)
    }
  }, [selection])
  // Formik validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: initialValues.id,
      current_status: initialValues.current_status,
      target_groups: initialValues.target_groups,
      published: initialValues.published,
      start_time: initialValues.start_time,
      end_time: initialValues.end_time,
      header_fi: initialValues.header_fi,
      header_en: initialValues.header_en,
      header_sv: initialValues.header_sv,
      description_fi: initialValues.description_fi,
      description_en: initialValues.description_en,
      description_sv: initialValues.description_sv,
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      setError(null)
      console.log("Submit values: ", values)

      let copy = structuredClone(values)
      if (copy.target_groups != null && copy.target_groups.length > 0) {
        copy.target_groups = copy.target_groups.join(",")
      } else {
        copy.target_groups = ""
      }

      copy.description_fi = sanitizeHtml(
        copy.description_fi,
        bulletinSanitizeSettings
      )
      copy.description_en = sanitizeHtml(
        copy.description_en,
        bulletinSanitizeSettings
      )
      copy.description_sv = sanitizeHtml(
        copy.description_sv,
        bulletinSanitizeSettings
      )

      console.log("Submit final values: ", copy)

      if (values.id < 0) {
        insertBulletin(copy)
      } else {
        updateBulletin(copy)
      }
    },
  })

  useEffect(() => {
    // console.log("changed values", validation.values)
    setExample(handleExample(validation.values))
  }, [validation.values])

  // Insert bulletin
  const insertBulletin = vals => {
    setOngoingInsert(true)
    insertStatusReport(abortRef.current, vals, props.productionDatabase)
      .then(result => {
        if (result == "OK") {
          showToast(props.t("Updated"), "success")
          // props.fetchReleases

          props.setCount(1)
        } else {
          showToast(props.t("Error"), "error")
        }
      })
      .catch(err => {
        console.log(err)
        showToast(props.t("Error"), "error")
      })
      .finally(() => {
        setOngoingInsert(false)
      })
  }

  // Update bulletin
  const updateBulletin = vals => {
    setOngoingInsert(true)
    updateStatusReport(abortRef.current, vals, props.productionDatabase)
      .then(result => {
        if (result == "OK") {
          showToast(props.t("Updated"), "success")
          // props.fetchReleases

          props.setCount(1)
        } else {
          showToast(props.t("Error"), "error")
        }
      })
      .catch(err => {
        console.log(err)
        showToast(props.t("Error"), "error")
      })
      .finally(() => {
        setOngoingInsert(false)
      })
  }

  // Create new bulletin draft
  const createBulletin = () => {
    let temp = new Object()
    temp.id = -1
    temp.start_time = dayjs()
    temp.end_time = null
    temp.published = false
    temp.target_groups = []
    temp.current_status = 1
    temp.header_fi = ""
    temp.header_en = ""
    temp.header_sv = ""
    temp.description_fi = ""
    temp.description_en = ""
    temp.description_sv = ""

    setSelection(temp)
    setInitialValues(temp)
    // setSelectedIndex(null)
  }

  const changeSteps = value => {
    setCurrentStep(value)
  }
  const nextStep = () => {
    setCurrentStep(currentStep + 1)
  }
  const prevStep = () => {
    setCurrentStep(currentStep - 1)
  }
  const steps = modalSteps.map(item => ({
    key: item.title,
    title: item.title,
  }))

  return (
    <>
      <Modal isOpen={initialValues !== null} centered size="lg">
        <ModalBody>
          <div className="p-2">
            <Form
              className="form-horizontal"
              onSubmit={e => {
                e.preventDefault()
                return false
              }}
            >
              {error ? <Alert color="danger">{props.t(error)}</Alert> : null}
              <Steps
                type="navigation"
                size="small"
                className="pb-3 pt-0"
                current={currentStep}
                items={steps}
                onChange={validation.values.version === "" ? null : changeSteps}
              ></Steps>
              {currentStep == 0 && (
                <div>
                  <Row xs={1} sm={2}>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Status")}</Label>
                        <Select
                          value={validation.values.current_status + ""}
                          onChange={(v) => { validation.setFieldValue("current_status", v) }}
                          options={[
                            { label: props.t("Service outage"), value: "1" },
                            { label: props.t("Service disruption"), value: "2" },
                            { label: props.t("Service operational"), value: "3" },
                          ]}
                          style={{ width: 100 + "%" }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Affected services")}</Label>
                        <Select
                          className=""
                          allowClear
                          mode="multiple"
                          placeholder={props.t("Select services")}
                          style={{ width: "100%" }}
                          value={validation.values.target_groups}
                          onChange={v =>
                            validation.setFieldValue("target_groups", v)
                          }
                          listHeight={400}
                        >
                          <Option value="1">
                            {props.t("Suvanto Care app")}
                          </Option>
                          <Option value="2">{props.t("Video call")}</Option>
                          <Option value="3">
                            {props.t("Group video call")}
                          </Option>
                          <Option value="4">{props.t("Carephone")}</Option>
                          {/* <Option value="5">
                            {props.t("Medicine reminder")}
                          </Option> */}
                          <Option value="6">
                            {props.t("Suvanto On the Go")}
                          </Option>
                          <Option value="7">{props.t("Suvanto Home")}</Option>
                          <Option value="8">{props.t("Smartlock")}</Option>
                          <Option value="9">
                            {props.t("Suvanto Care webpage")}
                          </Option>
                          <Option value="10">{props.t("Smartwatch")}</Option>
                        </Select>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label>{props.t("Start time")}</Label>
                        <DatePicker
                          style={{ width: "100%" }}
                          showTime
                          format="DD.MM.YYYY HH:mm"
                          value={validation.values.start_time}
                          onChange={v =>
                            validation.setFieldValue("start_time", v)
                          }
                        />
                      </FormGroup>
                    </Col>{" "}
                    <Col>
                      <FormGroup>
                        <Label>{props.t("End time")}</Label>
                        <DatePicker
                          style={{ width: "100%" }}
                          showTime
                          format="DD.MM.YYYY HH:mm"
                          value={validation.values.end_time}
                          onChange={v =>
                            validation.setFieldValue("end_time", v)
                          }
                        />
                      </FormGroup>
                    </Col>
                    <FormGroup>
                      <Label>{props.t("Bulletin published")}</Label>
                      <Switch
                        className="ms-2"
                        name="published"
                        checked={validation.values.published}
                        onChange={v => validation.setFieldValue("published", v)}
                        checkedChildren={props.t("Yes")}
                        unCheckedChildren={props.t("No")}
                      ></Switch>
                      {/* <Label>{props.t("Release note published")}</Label> */}
                    </FormGroup>
                  </Row>
                  {example && (
                    <div>
                      <div>
                        {selection &&
                          selection.guid &&
                          props.productionDatabase && (
                            <span className="float-end">
                              <a
                                className=""
                                href={"/disturbance-notice/" + selection.guid}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <i className="bx bx-link-external me-1"></i>
                                {props.t("Public link")}
                              </a>
                            </span>
                          )}
                        <span className="h6">
                          {props.t("Bulletin preview")}
                        </span>
                      </div>
                      <Card className="shadow-none border mx-2 my-1">
                        <div className="">
                          <ul className="list-group list-group-flush">
                            <li key="example" className="list-group-item py-2">
                              <DisturbanceListItem
                                item={example}
                              // onOpenModal={() => {
                              //   setModal(!modal)
                              // }}
                              />
                            </li>
                          </ul>
                        </div>
                      </Card>
                    </div>
                  )}
                </div>
              )}
              {currentStep == 1 && (
                <>
                  <ButtonGroup size="sm" className="mb-4 mt-3">
                    <Button
                      color="primary"
                      active={selectedLang === 1}
                      onClick={() => setSelectedLang(1)}
                    >
                      Suomi
                    </Button>
                    <Button
                      color="primary"
                      active={selectedLang === 2}
                      onClick={() => setSelectedLang(2)}
                    >
                      Englanti
                    </Button>
                    <Button
                      color="primary"
                      active={selectedLang === 3}
                      onClick={() => setSelectedLang(3)}
                    >
                      Ruotsi
                    </Button>
                  </ButtonGroup>

                  {selectedLang === 1 && (
                    <div>
                      <FormGroup>
                        <Label>{props.t("Title") + " (fi)"}</Label>
                        <AntdInput
                          allowClear
                          placeholder={props.t("Title")}
                          value={validation.values.header_fi}
                          onChange={(v) => { validation.setFieldValue("header_fi", v.target.value) }}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label>{props.t("Description") + " (fi)"}</Label>
                        {/* <TextArea
                          allowClear
                          autoSize={{ minRows: 8, maxRows: 12 }}
                          placeholder={props.t("Description")}
                          value={validation.values.description_fi}
                          onChange={(v) => { validation.setFieldValue("description_fi", v.target.value) }}
                        /> */}
                        <ReactQuill
                          theme="snow"
                          className="quill-custom minimum-height"
                          placeholder={props.t("Description")}
                          value={validation.values.description_fi}
                          onChange={html => {
                            validation.setFieldValue("description_fi", html)
                          }}
                          modules={quillModules}
                          formats={quillFormats}
                        />
                      </FormGroup>
                    </div>
                  )}

                  {selectedLang === 2 && (
                    <div>
                      <FormGroup>
                        <Label>{props.t("Title") + " (en)"}</Label>
                        <AntdInput
                          allowClear
                          placeholder={props.t("Title")}
                          value={validation.values.header_en}
                          onChange={(v) => { validation.setFieldValue("header_en", v.target.value) }}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label>{props.t("Description") + " (en)"}</Label>
                        {/* <TextArea
                          allowClear
                          autoSize={{ minRows: 8, maxRows: 12 }}
                          placeholder={props.t("Description")}
                          value={validation.values.description_en}
                          onChange={(v) => { validation.setFieldValue("description_en", v.target.value) }}
                        /> */}
                        <ReactQuill
                          theme="snow"
                          className="quill-custom minimum-height"
                          placeholder={props.t("Description")}
                          value={validation.values.description_en}
                          onChange={html => {
                            validation.setFieldValue("description_en", html)
                          }}
                          modules={quillModules}
                          formats={quillFormats}
                        />
                      </FormGroup>
                    </div>
                  )}

                  {selectedLang === 3 && (
                    <div>
                      <FormGroup>
                        <Label>{props.t("Title") + " (sv)"}</Label>
                        <AntdInput
                          allowClear
                          placeholder={props.t("Title")}
                          value={validation.values.header_sv}
                          onChange={(v) => { validation.setFieldValue("header_sv", v.target.value) }}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label>{props.t("Description") + " (sv)"}</Label>
                        {/* <TextArea
                          allowClear
                          autoSize={{ minRows: 8, maxRows: 12 }}
                          placeholder={props.t("Description")}
                          value={validation.values.description_sv}
                          onChange={(v) => { validation.setFieldValue("description_sv", v.target.value) }}
                        /> */}
                        <ReactQuill
                          theme="snow"
                          className="quill-custom minimum-height"
                          placeholder={props.t("Description")}
                          value={validation.values.description_sv}
                          onChange={html => {
                            validation.setFieldValue("description_sv", html)
                          }}
                          modules={quillModules}
                          formats={quillFormats}
                        />
                      </FormGroup>
                    </div>
                  )}
                  {example && (
                    <div>
                      <div>
                        {selection &&
                          selection.guid &&
                          props.productionDatabase && (
                            <span className="float-end">
                              <a
                                className=""
                                href={"/disturbance-notice/" + selection.guid}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <i className="bx bx-link-external me-1"></i>
                                {props.t("Public link")}
                              </a>
                            </span>
                          )}
                        <span className="h6">
                          {props.t("Bulletin preview")}
                        </span>
                      </div>
                      <Card className="shadow-none border mx-2 my-1">
                        <div className="">
                          <ul className="list-group list-group-flush">
                            <li key="example" className="list-group-item py-2">
                              <DisturbanceListItem
                                item={example}
                              // onOpenModal={() => {
                              //   setModal(!modal)
                              // }}
                              />
                            </li>
                          </ul>
                        </div>
                      </Card>
                    </div>
                  )}
                </>
              )}

              <div
                style={{
                  marginTop: 24,
                }}
              >
                {currentStep == 0 && (
                  <Button
                    color="primary"
                    disabled={ongoingInsert}
                    style={{ minWidth: "160px" }}
                    onClick={() => {
                      validation.submitForm()
                    }}
                  >
                    <i className="bx bxs-save me-1"></i>
                    {props.t("Save")}
                  </Button>
                )}
                <Button
                  color="primary"
                  outline
                  className="ms-2"
                  onClick={() => {
                    props.setSelection(null)
                    props.modal(false)
                  }}
                >
                  {props.t("Cancel")}
                </Button>

                {currentStep < modalSteps.length - 1 && (
                  <>
                    {currentStep === 1 ? (
                      <Button
                        color="primary"
                        disabled={ongoingInsert}
                        style={{ minWidth: "160px" }}
                        onClick={() => {
                          validation.submitForm()
                        }}
                      >
                        <i className="bx bxs-save me-1"></i>
                        {props.t("Save")}
                      </Button>
                    ) : (
                      <Button
                        className="float-end"
                        color="primary"
                        onClick={() => nextStep()}
                        disabled={validation.values.version == ""}
                      >
                        {props.t("Next")}
                      </Button>
                    )}
                  </>
                )}
                {currentStep > 0 && (
                  <>
                    <Button
                      className="float-end"
                      color="primary"
                      disabled={ongoingInsert}
                      style={{ minWidth: "160px" }}
                      onClick={() => {
                        validation.submitForm()
                      }}
                    >
                      <i className="bx bxs-save me-1"></i>
                      {props.t("Save")}
                    </Button>
                    <Button
                      className="float-end"
                      color="primary"
                      style={{
                        margin: "0 8px",
                      }}
                      onClick={() => prevStep()}
                    >
                      {props.t("Previous")}
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

ErrorBulletinsModal.propTypes = {
  t: PropTypes.any,
  selection: PropTypes.any,
  setSelection: PropTypes.any,
  productionDatabase: PropTypes.any,
  modal: PropTypes.any,
  //fetchReleases: PropTypes.func,
  setCount: PropTypes.func,
}

export default withRouter(withTranslation()(ErrorBulletinsModal))
